import { render, staticRenderFns } from "./DepositInfoItem.vue?vue&type=template&id=69bdd633&scoped=true"
import script from "./DepositInfoItem.vue?vue&type=script&lang=ts"
export * from "./DepositInfoItem.vue?vue&type=script&lang=ts"
import style0 from "./DepositInfoItem.vue?vue&type=style&index=0&id=69bdd633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bdd633",
  null
  
)

export default component.exports